var rrspAuth = rrspAuth || {};

/*	-----------------------------------------------------------------------------------------------
	Login
--------------------------------------------------------------------------------------------------- */
rrspAuth.login = {
    init() {
        this.setListeners();
    },

    setListeners() {
        var self = this;

        $("#home-login-form").submit(function (e) {
            e.preventDefault();
            let form = $(this);
            let url = form.attr('action');

            $.ajax({
                type: "POST",
                url: url,
                data: form.serialize(),
                dataType: "json",
                beforeSend: function(){
                  self.initializeSubmission();
                },
                success: function(data) {
                    self.handleOutput(data);
                }
            });
        });
    },

    initializeSubmission() {
        $('#login-form-alert').addClass('d-n').removeClass('alert-danger').removeClass('alert-success');
        $('#home-login-form .btn.btn-login').addClass('-loading').html('<i class="fa fa-cog fa-spin" aria-hidden="true"></i>');
    },

    handleOutput(result) {
        if( result.success ) {
            $('#login-form-alert').html(result.output);
            $('#login-form-alert').addClass('alert-success');
            location.reload();
        } else {
            $('#login-form-alert').html(result.errors.err);
            $('#login-form-alert').addClass('alert-danger');
        }

        $('#login-form-alert').removeClass('d-n');
        $('#home-login-form .btn.btn-login').removeClass('-loading').html('Login');
    }
} // rrspAuth.login



/**
 * Is the DOM ready
 *
 * this implementation is coming from https://gomakethings.com/a-native-javascript-equivalent-of-jquerys-ready-method/
 *
 * @param {Function} fn Callback function to run.
 */
function rrspDomReady( fn ) {
	if ( typeof fn !== 'function' ) {
		return;
	}

	if ( document.readyState === 'interactive' || document.readyState === 'complete' ) {
		return fn();
	}

	document.addEventListener( 'DOMContentLoaded', fn, false );
}

rrspDomReady( () => {
	rrspAuth.login.init();	    // Handle login
} );
